<template>
  <div class="btn-card-container">
    <v-btn depressed class="tertiary-txt-btn" @click="submitAnswer(1)" v-show="!contentData.responses.hideButton1">{{
      contentData.responses.button_1
    }}</v-btn>
    <v-btn depressed class="tertiary-txt-btn" @click="submitAnswer(2)" v-show="!contentData.responses.hideButton2">{{
      contentData.responses.button_2
    }}</v-btn>
    <v-btn
      depressed
      class="tertiary-txt-btn"
      @click="submitAnswer(3)"
      v-show="contentData.responses.hideButton3 === false"
      >{{ contentData.responses.button_3 }}</v-btn
    >
  </div>
</template>
<script>
export default {
  name: "ButtonsCard",
  data() {
    return {
      contentData: {
        responses: {
          button_1: "Ja",
          button_2: "Nein",
          button_3: "Beides",
          hideButton1: false,
          hideButton2: false,
          hideButton3: true,
          linkButton1: undefined,
          linkButton2: undefined,
          linkButton3: undefined,
        },
      },
    }
  },
  methods: {
    submitAnswer(userResponse) {
      console.log(userResponse)

      let newInput = {}
      if (userResponse == 1) {
        newInput = {
          button1: {
            clicked: true,
          },
        }
        if (this.contentData.responses.linkButton1 !== undefined) {
          this.openLinkInNewWindow(this.contentData.responses.linkButton1)
        }
      } else if (userResponse == 2) {
        newInput = {
          button2: {
            clicked: true,
          },
        }
        if (this.contentData.responses.linkButton2 !== undefined) {
          this.openLinkInNewWindow(this.contentData.responses.linkButton2)
        }
      } else {
        newInput = {
          button3: {
            clicked: true,
          },
        }
        if (this.contentData.responses.linkButton3 !== undefined) {
          this.openLinkInNewWindow(this.contentData.responses.linkButton3)
        }
      }

      this.$emit("submitAnswer", newInput)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Buttons Card")

      let updatedContent = {
        responses: {
          button_1: executableSystemAction.guiTemplateContent.button1.text,
          button_2: executableSystemAction.guiTemplateContent.button2.text,
          button_3: executableSystemAction.guiTemplateContent.button3?.text,
          hideButton1: executableSystemAction.guiTemplateContent.button1.hidden,
          hideButton2: executableSystemAction.guiTemplateContent.button2.hidden,
          hideButton3: executableSystemAction.guiTemplateContent.button3?.hidden,
          linkButton1: executableSystemAction.guiTemplateContent.button1.href,
          linkButton2: executableSystemAction.guiTemplateContent.button2.href,
          linkButton3: executableSystemAction.guiTemplateContent.button3?.href,
        },
      }

      console.log(updatedContent)

      this.contentData = updatedContent
    },
    //checks for variables in link to replace and opens the proper link in a new tab
    openLinkInNewWindow(currentLink) {
      let re = new RegExp("\\$([A-Za-z0-9]+)", "g")
      let regexResult = [...currentLink.matchAll(re)]

      for (let res of regexResult) {
        // TODO check if product array is requird elsewhere => then implement BE
        // Potential Refactoring Candidate: URL Substitution Frontend or Backend?
        // implementation for generating product id query param in frontend
        if (res[1] == "FRONTENDPRODUCTIDARRAY") {
          // concat product IDs with ,
          const prdIDArrayString = Object.keys(this.$parent.$parent.$parent.$parent.originalFlowState.basket).join(
            ","
          )
          currentLink = currentLink.replace("$" + res[1], prdIDArrayString)
        } else {
          res[1] in this.$parent.$parent.$parent.$parent.originalFlowState.variables
          currentLink = currentLink.replace(
            "$" + res[1],
            this.$parent.$parent.$parent.$parent.originalFlowState.variables[res[1]]
          )
        }
      }

      window.open(currentLink)
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>
